import * as React from "react";
import {Component} from "react";
import {DashboardFullPeriodCPAVsPeriodCell} from "./DashboardFullPeriodCPAVsPeriodCell";

export class DashboardYesterdayCPAVsPeriodCell extends Component {
    render() {
        return <DashboardFullPeriodCPAVsPeriodCell columnData={this.props.data} columnTooltip={this.titleFor()}
                                                   businessUnitId={this.props.businessUnitId}
        />;
    }

    titleFor() {
        return `El CPA de ayer fue ${this.props.data.formatted_value}. El CPA esperado es ${this.props.data.formatted_expected_value}`;
    }
}
